import * as React from "react";
const SvgLow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 9L12 15L6 9", stroke: "#4586F7", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgLow;
